import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  NgbToastModule,
  NgbProgressbarModule,
  NgbModule,
} from "@ng-bootstrap/ng-bootstrap";
import { FlatpickrModule } from "angularx-flatpickr";
import { CountToModule } from "angular-count-to";
import { NgApexchartsModule } from "ng-apexcharts";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { SimplebarAngularModule } from "simplebar-angular";
import { SwiperModule } from "ngx-swiper-wrapper";
import { SWIPER_CONFIG } from "ngx-swiper-wrapper";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";
import { LightboxModule } from "ngx-lightbox";
import { defineLordIconElement } from "lord-icon-element";
import lottie from "lottie-web";
import { PagesRoutingModule } from "./pages-routing.module";
import { SharedModule } from "../shared/shared.module";
import { NotFoundComponent } from "./not-found/not-found.component";
import { AboutComponent } from "./about/about.component";
import { LaddaModule } from "angular2-ladda";
import { NgxLoadingModule, ngxLoadingAnimationTypes } from "ngx-loading";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { ChangePasswordService } from "./change-password/change-password.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { ProfileComponent } from "./profile/profile.component";
import { AgreementPt2GridComponent } from "./profile/agreement-pt2-grid/agreement-pt2-grid.component";
import { AgreementModelComponent } from "./profile/agreement-pt2-grid/agreement-model/agreement-model.component";
import { InputTrimModule } from "ng2-trim-directive";
import { HoldingAccountBankAccountGridComponent } from './holding-account-bank-account/holding-account-bank-account-grid/holding-account-bank-account-grid.component';
import { HoldingAccountGridComponent } from './holding-account-bank-account/holding-account-grid/holding-account-grid.component';
import { ClientAccountGridComponent } from './client-account/client-account-grid/client-account-grid.component';
import { ClientAccountCurrencyGridComponent } from './client-account/client-account-currency-grid/client-account-currency-grid.component';
import { ClientAccountBreakdownGridComponent } from './client-account/client-account-breakdown-grid/client-account-breakdown-grid.component';


const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: "horizontal",
  slidesPerView: "auto",
};
@NgModule({
  declarations: [
    NotFoundComponent,
    AboutComponent,
    ChangePasswordComponent,
    ProfileComponent,
    AgreementPt2GridComponent,
    AgreementModelComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    NgbToastModule,
    NgbProgressbarModule,
    FlatpickrModule.forRoot(),
    CountToModule,
    NgApexchartsModule,
    LeafletModule,
    NgbDropdownModule,
    SimplebarAngularModule,
    PagesRoutingModule,
    SharedModule,
    SwiperModule,
    LightboxModule,
    AngularEditorModule,
    InputTrimModule,
    LaddaModule.forRoot({
      style: "expand-right",
      spinnerSize: 30,
      spinnerColor: "white",
      spinnerLines: 12,
    }),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.doubleBounce,
      backdropBorderRadius: "4px",
      primaryColour: "#d7e7db",
      secondaryColour: "#57a170",
    }),
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
    ChangePasswordService,
    AgreementPt2GridComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PagesModule {
  constructor() {
    defineLordIconElement(lottie.loadAnimation);
  }
}
